module.exports = __webpack_public_path__ + "img/rdstation.e4ac0cbf.png";